var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"ab-section",class:_vm.spacing !== null
      ? [
          `ab-section_top-${_vm.spacing?.top ?? _setup.DEFAULT_SPACING.top}`,
          `ab-section_bottom-${_vm.spacing?.bottom ?? _setup.DEFAULT_SPACING.bottom}`,
        ]
      : '',attrs:{"id":_vm.id ?? undefined}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }